import {
  Box,
  Button,
  Drawer,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { Card } from "../../ui/Card";
import toast from "react-hot-toast";
import { OrderRowType } from "./OrderData";
import { GridRowSelectionModel } from "@mui/x-data-grid";
import { bulkdownloadAwb } from "./orderApi";

const MultipleOrderBulkDownloadDrawer = ({
  ids,
  data,
  open,
  handleClose,
}: {
  ids: GridRowSelectionModel;
  data: OrderRowType[];
  open: boolean;
  handleClose: () => void;
}) => {
  const [loading, setLoading] = useState(false);

  const handleBulkDownload = async () => {
    setLoading(true);
    try {
      // Call your API to download bulk AWB, adjust as needed
    bulkdownloadAwb({ doc_type: "scheduled_pickup", shipment_ids: ids })
        .then((data) => {
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(data.data);
          downloadLink.download = `order_scheduled_pickup.pdf`;
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        })
        .catch((error) => {
          toast.error(
            "Incorrect Shipment AWBs or IDs, Please enter the Correct data."
          );
        });
      toast.success("Bulk AWB download started!");
      handleClose();
    } catch (error) {
      toast.error("Failed to download bulk AWB.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Drawer open={open} onClose={handleClose} anchor="right">
      <div className="multiple-order-assign">
        <Box sx={{ padding: "10px 30px" }}>
          <Box sx={{ fontWeight: 600, fontSize: 22, mb: 3 }}>
            Bulk Download AWB
          </Box>
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              marginBottom: "40px",
              flexWrap: "wrap",
              rowGap: "20px",
              marginTop: "20px",
            }}
          >
            <Button
              onClick={handleBulkDownload}
              variant="contained"
              disabled={loading}
            >
              {loading ? "Downloading..." : "Download Bulk AWB"}
            </Button>
          </Stack>
          <TableContainer component={Card}>
            <Table sx={{ minWidth: 650 }} aria-label="orders table">
              <TableHead>
                <TableRow>
                  <TableCell>id</TableCell>
                  <TableCell>Vendor</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell>From</TableCell>
                  <TableCell>Receiver</TableCell>
                  <TableCell>Amount</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell>{row?.id}</TableCell>
                    <TableCell>{row?.vendor}</TableCell>
                    <TableCell>{row?.description}</TableCell>
                    <TableCell>
                      {row?.from}-{row?.to}
                    </TableCell>
                    <TableCell>{row?.receiver}</TableCell>
                    <TableCell>{row?.amount}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    </Drawer>
  );
};

export default MultipleOrderBulkDownloadDrawer;
